import type { QueryClient } from '@tanstack/react-query';

import { bootAccessLoader } from '../access';
import { onboardingStatusQueryOptions } from '../modules/onboarding';
import { isLocalSessionOpen } from '../session/localSession';

export const bootLoader = (queryClient: QueryClient) => {
  const loadAccess = bootAccessLoader(queryClient);
  return async (): Promise<null> => {
    if (isLocalSessionOpen()) void queryClient.prefetchQuery(onboardingStatusQueryOptions());
    return loadAccess();
  };
};
